<template>
  <div class="article-page">
    <search-component v-if="!comeFromOldSystem" />
    <privilidge
      :has-privilidge="hasPrivilidge"
      :mounted-parent="getArticle"
    />
    <div class="article-view">
      <div>
        <h2
          class="title"
          align="center"
        >{{ article.Title }}</h2>
        <h4
          v-if="article.SubTitle"
          class="subtitle"
          align="center"
        >{{ article.SubTitle }}</h4>
        <p
          class="article-info margin-bottom16"
          align="center"
        >
          <span class="date">{{ showPublish(article) }}</span>

          <span
            v-if="article.DomainName && comeFromOldSystem"
            style="margin-left: 20px;"
          >数据来源:
            <a
              v-if="article.Url"
              :href="article.Url"
              target="_blank"
            >{{ article.DomainName }}</a>
            <span v-if="!article.Url">{{ article.DomainName }}</span>
          </span>

          <span
            v-if="article.SourceName && article.SourceName!='-'"
            style="margin-left: 20px;"
          >文章来源:
            <span>{{ article.SourceName }}</span>
          </span>
          <span
            v-if="article.Author"
            style="margin-left: 20px;"
          >作者:
            <span>{{ article.Author }}</span>
          </span>
          <span
            v-if="article.DomainLevel1 && comeFromOldSystem"
            style="margin-left: 20px;"
          >领域:
            <span>{{ article.DomainLevel1 }}</span>
            <span v-if="article.DomainLevel2">>{{ article.DomainLevel2 }}</span>
          </span>
          <span
            v-if="article.PropertyLevel1"
            style="margin-left: 20px;"
          >属性:
            <span>{{ article.PropertyLevel1 }}</span>
            <span v-if="article.PropertyLevel2">>{{ article.PropertyLevel2 }}</span>
          </span>
        </p>
        <hr>
        <div
          class="artical-content scroll-container"
          style=""
        >
          <div class="article-overview">
            <div v-if="article.DocumentAgent"><b>发文机关:</b> {{ article.DocumentAgent }}</div>
            <div v-if="article.DocumentNumber"><b>发文字号: </b>{{ article.DocumentNumber }}</div>
            <div v-if="article.FileNumber"><b>档案号:</b> {{ article.FileNumber }}</div>
            <div v-if="article.Keywords && article.Keywords.length>0 && comeFromOldSystem"><b>关键词:</b> {{ article.Keywords.join(',') }}</div>
            <div v-if="article.Summary && comeFromOldSystem"><b>摘要:</b> {{ article.Summary }}</div>

          </div>
          <div
            v-if="videoFile.length"
            class="media-box"
          >
            <div
              class="video1 video-player"
            />
            <!-- <object
              :data="sourceUrl"
              style="object-fit: fill;"
              class="video-player"
            >
              <param
                name="displaysize"
                value="1"
              >
              <embed
                :src="sourceUrl"
                class="video-player"
              >
            </object> -->
            <p>{{ videoFileName | videoNameFilters }}</p>
            <!-- <el-carousel height="250px">
              <el-carousel-item
                v-for="item in imgFileList"
                :key="item.StoreId"
              >
                <img :src="item.sourceUrl">
              </el-carousel-item>
            </el-carousel> -->
          </div>
          <div
            class="content"
            v-html="article.MainContent"
          />
        </div>

        <div
          v-if="article.Attachments && article.Attachments.length > 0"
          class="attach-list"
        >
          <span>附件:</span>
          <ul>
            <li
              v-for="item in article.Attachments"
              :key="item.StoreId"
            >
              <div>
                <span>
                  {{ item.FileName }}
                </span>
                <a
                  v-if="item.StoreId && downloadFilter(item.FileName)"
                  href="javascript:void(0)"
                  @click="downAttachment(item.StoreId)"
                >下载</a>
                <a
                  v-if="item.OnlineVideoUrl"
                  href="javascript:void(0)"
                  @click="tovideoPlayer(item.StoreId)"
                >播放</a>
                <a
                  v-if="item.OnlineViewUrl"
                  href="javascript:void(0)"
                  @click="checkAttachment(item.OnlineViewUrl)"
                >查看</a>
              </div>
            </li>
          </ul>
        </div>
        <hr v-if="recommendList[0] && recommendList[0].length!==0">
        <div v-if="recommendList[0] && recommendList[0].length!==0">
          <span
            class="recommend-title"
            style="vertical-align: top;"
          >相关阅读</span>
          <div>
            <div style="display:inline-block;width:45%;margin-right:5%">
              <a
                v-for="(i,index) in recommendList[0]"
                :key="index"
                :title="i.littleTitle"
                style="display:block"
                href="javascript:void(0)"
                @click="turnToDetail(i)"
              >{{ i.Title }}
                <i
                  v-if="i.Locked && !isLogin"
                  class="lock-icon"
                />
              </a>
            </div>
            <div style="display:inline-block;width:45%;vertical-align: top">
              <a
                v-for="(i,index) in recommendList[1]"
                :key="index"
                :title="i.littleTitle"
                style="display:block"
                href="javascript:void(0)"
                @click="turnToDetail(i)"
              >{{ i.Title }}
                <i
                  v-if="i.Locked && !isLogin"
                  class="lock-icon"
                />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import * as service from '@/service/httpService'
// components
import searchComponent from '@/components/searchComponent'
import privilidge from '@/modules/common/privilidge-out.vue'

export default {
  name: 'ArticleView',
  components: { searchComponent, privilidge },
  filters: {
    videoNameFilters (val) {
      return val.substr(0, val.length - 4)
    }
  },
  data () {
    return {
      article: {},
      recommendList: [],
      // 新系统专用
      hasPrivilidge: true,
      sourceUrl: null,
      videoObject: {
        container: '.video1',  // “#”代表容器的ID，“.”或“”代表容器的class
        variable: 'player', // 该属性必需设置，值等于下面的new chplayer()的对象
        poster: '', // 封面图片
        autoplay: true,
        volume: 2,
        video: '' // 视频地址
      },
      imgFileList: [],
      videoFile: []
    }
  },
  computed: {
    ...mapState({
      isLogin: 'isLogin',
      comeFromOldSystem: 'comeFromOldSystem'
    }),
    getId () {
      return this.$route.params.id
    },
    videoFileName () {
      return this.videoFile[0] && this.videoFile[0].FileName
    }
  },
  mounted () {
    this.getArticle()
  },
  methods: {
    ...mapMutations({
      loginShow: 'LOGIN_SHOW'
    }),
    getArticle () {
      const that = this
      let url = window.dataUrl.History.article.replace('{id}', this.getId)
      service.historyEventService.loadColums(url, {autoTags: true}).then(res => {
        let {origin} = window.location
        if (process.env.NODE_ENV === 'development') {
          origin = window.globalConfig.webApi
        }
        const videoFile = res.data.Attachments.filter((attachment) => {
          return attachment.FileName.includes('.mp4') ||
          attachment.FileName.includes('.AVI') ||
          attachment.FileName.includes('.mov') ||
          attachment.FileName.includes('.rmvb') ||
          attachment.FileName.includes('.rm') ||
          attachment.FileName.includes('.FLV') ||
          attachment.FileName.includes('.3GP')
        })
        this.videoFile = videoFile
        this.imgFileList = res.data.Attachments.filter((attachment) => {
          return attachment.FileName.includes('.png') ||
          attachment.FileName.includes('.jpg') ||
          attachment.FileName.includes('.jpeg')
        }).map((attachment) => {
          const obj = {
            ...attachment,
            sourceUrl: `${origin}/api/v2/files/download/${attachment.StoreId}`
          }
          return obj
        })
        if (videoFile.length) {
          const videoStoreId = videoFile[0].StoreId
          // this.sourceUrl = `../../../static/videoPlayer.html?source=${origin}/api/v2/files/download/${videoStoreId}`
          this.sourceUrl = `${origin}/api/v2/files/download/${videoStoreId}`
          that.videoObject.video = that.sourceUrl
          this.$nextTick(() => {
          // eslint-disable-next-line no-unused-vars
            let player = new ckplayer(that.videoObject)
          })
          // this.initVideo()
        }
        this.article = res.data
        document.title = this.comeFromOldSystem ? this.article.Title : this.article.Title + '_中国改革开放全纪录（1978-2018）_中国改革开放数据库'
        let content = this.article.MainContent
        content = content.replace(/<br\/>/g, '</p><br/><p>')
        content = content.replace(/<\/p><p>/g, '</p><br/><p>')
        this.article.MainContent = content
      }, err => {
        if (err.status === 403) {
          this.hasPrivilidge = false
        }
      })
      let recommendUrl = window.dataUrl.History.recommend.replace('{id}', this.getId)
      service.historyEventService.loadRecommend(recommendUrl).then(res => {
        let data = res.data
        // 26
        data.forEach(e => {
          if (e.Title.length > 26) {
            e.littleTitle = e.Title
            e.Title = e.littleTitle.substr(0, 25) + '...'
          } else {
            e.littleTitle = e.Title
          }
        })
        this.recommendList = [[], []]
        for (let i = 0; i < data.length; i++) {
          if (i % 2 === 0) {
            this.recommendList[0].push(data[i])
          } else {
            this.recommendList[1].push(data[i])
          }
        }
        // this.recommendList = res.data
      })
    },
    downloadFilter (fileName) { // 隐藏视频下载
      const videoFormat = ['.mp4', '.AVI', '.mov', '.rmvb', '.rm', '.FLV', '.3GP']
      return !videoFormat.some(item => fileName.includes(item))
    },
    showPublish (item) {
      return window.moment(item.PublishTime).format('YYYY-MM-DD')
    },
    downAttachment (storeId) {
      service.FileManageV2.download(storeId)
    },
    checkAttachment (OnlineViewUrl) {
      window.open(OnlineViewUrl)
    },
    turnToDetail (i) {
      if (i.Locked && !this.isLogin) {
        this.loginShow()
        return false
      }
      const { href } = this.$router.resolve({
        path: '/article/' + i.Id
      })
      window.open(href)
    },
    tovideoPlayer (id) {
      const {href} = this.$router.resolve({
        name: 'videoPlayer',
        query: {
          id: id
        }
      })
      window.open(href)
    }
  }
}
</script>


<style lang="scss">
.article-page {
  // position: absolute;
  // top: 65px;
  // bottom: 0;
  width: 100%;
  overflow-y: auto;

  strong {
    font-weight: bold;
  }
  em {
    font-style: italic;
  }
  ol {
    list-style: decimal;
  }
  ul {
    list-style: disc;
  }
  .article-view {
    width: 1000px;
    margin: 30px auto 50px;
    line-height: 30px;
    .title {
      font-size: 24px;
    }
    .subtitle {
      margin: 5px;
      font-size: 20px;
    }
    img {
      display: block;
      margin: 0 auto;
      max-width: 80%;
    }
  }
  .recommend-title {
    font-size: 18px;
    font-weight: bold;
  }

  .media-box {
    width: 850px;
    margin: 0 auto;
    text-align: center;
    // position: relative;
    // padding-bottom: 56.25%;
    // height: 0;
    overflow: hidden;

    .video-player {
      height: 500px;
    }
  }

  .media-box iframe,
  .media-box object,
  .media-box embed {
    // position: absolute;
    // top: 0;
    // left: 0;
    width: 100%;
    height: 100%;
    // object-fit: cover;
  }

  .content {
    text-indent: 2em;
  }
  .lock-icon {
    float: right;
    width: 14px;
    height: 14px;
    margin-top: 5px;
    background: url('../../assets/img/lock.png') no-repeat;
    background-size: 100% 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/history/article-view.vue